(() => {
  const source = document.getElementById('uplief-guarantee-config');
  if (!source) return;
  const config = JSON.parse(source.textContent);
  const rootPath = window.Shopify?.routes?.root || '/';
  const cartPath = action => `${rootPath}cart${action ? `/${action}` : ''}.js`;
  const root = () => document.querySelector('#opus-shadow-container')?.shadowRoot || document.querySelector('#opus-drawer-id');
  const sessionKey = `uplief-guarantee-choice-${config.variantId}`;
  let memoryChoice = null;
  const readChoice = () => {
    try { return sessionStorage.getItem(sessionKey) ?? memoryChoice; }
    catch { return memoryChoice; }
  };
  const writeChoice = value => {
    memoryChoice = value;
    try {
      if (value === null) sessionStorage.removeItem(sessionKey);
      else sessionStorage.setItem(sessionKey, value);
    } catch { /* Keep the choice for this page when storage is unavailable. */ }
  };
  let observedRoot, observer, busy = false, scheduled = false;
  const getCart = async () => {
    const response = await fetch(cartPath(''), {cache:'no-store'});
    if (!response.ok) throw new Error('Unable to read the cart.');
    return response.json();
  };
  const post = async (action, payload) => {
    const response = await fetch(cartPath(action), {
      method:'POST', headers:{'Content-Type':'application/json', Accept:'application/json'},
      body:JSON.stringify(payload)
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || 'Unable to update the cart.');
    return result;
  };
  const offerLines = cart => cart.items.filter(item => Number(item.variant_id) === Number(config.variantId));
  const hasMain = cart => cart.items.some(item => Number(item.product_id) !== Number(config.productId));
  const refresh = async () => {
    if (typeof window.opusRefreshCart === 'function') await window.opusRefreshCart();
    else window.dispatchEvent(new Event('ocu:cart:open:updated'));
  };
  function markLine(drawer) {
    const rows = drawer.querySelectorAll('.cd-product-item');
    for (const row of rows) {
      const link = row.querySelector('a.cd-product-item-title');
      if (!row.classList.contains('uplief-guarantee-line') && !link?.getAttribute('href')?.includes(`/products/${config.handle}`)) continue;
      if (!row.classList.contains('uplief-guarantee-line')) row.classList.add('uplief-guarantee-line');
      if (link) {
        const title = document.createElement('span');
        title.className = link.className;
        title.textContent = link.textContent;
        link.replaceWith(title);
      }
      const imageLink = row.querySelector('a.opus-product-item-image-container');
      if (imageLink) {
        const imageBox = document.createElement('div');
        imageBox.className = imageLink.className;
        imageBox.append(...imageLink.childNodes);
        imageLink.replaceWith(imageBox);
      }
      const image = row.querySelector('img');
      if (image && !image.classList.contains('uplief-guarantee-line-image')) image.classList.add('uplief-guarantee-line-image');
      const titleContainer = row.querySelector('.cd-product-item-title-container');
      if (titleContainer && config.details && !titleContainer.querySelector('.uplief-guarantee-details')) {
        const details = document.createElement('p');
        details.className = 'uplief-guarantee-details';
        details.textContent = config.details;
        titleContainer.append(details);
      }
    }
  }
  async function reconcile() {
    const drawer = root()?.querySelector('.opus-drawer-container.open');
    if (!drawer || busy) return;
    busy = true;
    try {
      const cart = await getCart();
      if (!drawer.isConnected) return;
      markLine(drawer);
      const lines = offerLines(cart);
      const choice = readChoice();
      if (!hasMain(cart)) {
        writeChoice(null);
        if (lines.length) {
          for (const line of lines) await post('change', {id:line.key, quantity:0});
          await refresh();
        }
        return;
      }
      if (lines.length) {
        writeChoice('on');
        return;
      }
      if (choice === 'on') {
        writeChoice('off');
        return;
      }
      if (!config.defaultSelected || choice === 'off') return;
      await post('add', {items:[{id:Number(config.variantId),quantity:1}]});
      writeChoice('on');
      await refresh();
    } catch (error) {
      console.error('Unable to update the 90-day guarantee cart item.', error);
    } finally {
      busy = false;
    }
  }
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    setTimeout(() => { scheduled = false; void reconcile(); }, 100);
  }
  function attach() {
    const tree = root();
    if (!tree || tree === observedRoot) return;
    observer?.disconnect();
    observedRoot = tree;
    const style = document.createElement('style');
    style.textContent = '.uplief-guarantee-line .opus-product-item-image-container{background:transparent!important;display:flex!important;align-items:center!important;justify-content:center!important;cursor:default!important}.uplief-guarantee-line-image{object-fit:contain!important;object-position:center center!important;margin:auto!important;display:block!important;max-width:100%!important;height:auto!important;transform:translateX(-12.5%)}.uplief-guarantee-line .opus-product-item-details{min-width:0!important}.uplief-guarantee-line .cd-number-input{display:none!important}.uplief-guarantee-line .cd-product-item-title,.uplief-guarantee-line .cd-product-item-title:hover,.uplief-guarantee-line .cd-product-item-title:focus{color:#111!important;cursor:default!important;text-decoration:none!important}.uplief-guarantee-line .cd-product-item-title-container{text-align:left}.uplief-guarantee-details{font-size:clamp(11px,2.8vw,12px);line-height:1.35;color:#666;margin:4px 0 0;max-width:100%;font-weight:400;white-space:pre-line;overflow-wrap:break-word}';
    (tree instanceof ShadowRoot ? tree : document.head).append(style);
    observer = new MutationObserver(records => {
      if (records.some(record => record.type === 'attributes' || record.addedNodes.length || record.removedNodes.length)) schedule();
    });
    observer.observe(tree, {childList:true, subtree:true,attributes:true,attributeFilter:['class']});
    schedule();
  }
  const interval = setInterval(attach, 500);
  window.addEventListener('pagehide', () => clearInterval(interval), {once:true});
  attach();
})();
